import styled from 'styled-components';

export const Title = styled.div`
    font-size: 30px;
    font-weight: bold;
    color: var(--white);
    span {
        color: var(--yellow);
    }
`;
